import axios from './interceptors';
import CryptoJS from 'crypto-js';
import { IUserInfo, ResponseResult } from '@/store/root-types';

export interface GetCaptchaResult {
    uuid: string;
    captcha: string;
}

export const getCaptcha = () => {
    return axios.request<ResponseResult<GetCaptchaResult>>({
        url: '/api/common/captcha',
        method: 'GET',
    });
};

export interface AuthorizeBody {
    code: string;
}

export interface AuthorizeResult {
    authority_id: string;
}

/**
 * 登录
 */
export const authorize = (data: AuthorizeBody) => {
    return axios.request<ResponseResult<AuthorizeResult>>({
        url: '/api/common/dy/authorize',
        method: 'GET',
        params: data,
    });
};

export interface LoginBody {
    username: string;
    password: string;
    // captcha: string;
    // code: string;
}

/**
 * 登录
 */
export const login = ({ username, password, ...data }: LoginBody) => {
    const _username = CryptoJS.MD5(username).toString();
    const _password = CryptoJS.MD5(_username + password).toString();
    return axios.request<ResponseResult>({
        url: '/api/common/ad/login',
        method: 'POST',
        data: { username: _username, password: _password, ...data },
    });
};

/**
 * 退出登录
 * @returns
 */
export const logout = () => {
    return axios.request<ResponseResult>({
        url: '/api/admin/user/logout',
        method: 'GET',
    });
};

/**
 * 获取用户信息
 * @returns
 */
export const getUserInfo = () => {
    return axios.request<ResponseResult<IUserInfo>>({
        url: '/api/admin/user/info',
        method: 'GET',
    });
};

export interface UpdateUserInfoBody {
    email: string;
    avatar: string;
    name: string;
    phone: string;
    work_wx_qrcode: string;
}

/**
 * 修改个人信息 (所有参数必填)
 */
export const updateUserInfo = (data: UpdateUserInfoBody) => {
    return axios.request<ResponseResult>({
        url: '/api/qd/user/update',
        method: 'POST',
        data,
    });
};

export interface UpdatePasswordBody {
    username: string;
    old_password: string;
    new_password: string;
    verify_password: string;
}

/**
 * 修改密码
 */
export const updatePassword = (data: UpdatePasswordBody) => {
    const username = data.username;
    const old_password = CryptoJS.MD5(username + data.old_password).toString();
    const new_password = CryptoJS.MD5(username + data.new_password).toString();
    const verify_password = CryptoJS.MD5(username + data.verify_password).toString();
    return axios.request<ResponseResult>({
        url: '/api/admin/user/change_password',
        method: 'POST',
        data: {
            old_password,
            new_password,
            verify_password,
        },
    });
};
